import MessageApi from '../../../../api/inbox/message';

let translationInFlight = false;

export function isMessageTranslationInFlight() {
  return translationInFlight;
}

export default {
  async translateMessage(_, { conversationId, messageId, targetLanguage }) {
    if (translationInFlight) {
      const error = new Error('translate_in_progress');
      error.code = 'translate_in_progress';
      throw error;
    }

    translationInFlight = true;
    try {
      await MessageApi.translateMessage(
        conversationId,
        messageId,
        targetLanguage
      );
    } finally {
      translationInFlight = false;
    }
  },
};
